import { render, staticRenderFns } from "./TeamRanks.vue?vue&type=template&id=89fd9a66&scoped=true"
import script from "./TeamRanks.vue?vue&type=script&lang=js"
export * from "./TeamRanks.vue?vue&type=script&lang=js"
import style0 from "./TeamRanks.vue?vue&type=style&index=0&id=89fd9a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fd9a66",
  null
  
)

export default component.exports